import { render } from "./Main.vue?vue&type=template&id=4b6c2ac2&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4b6c2ac2&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6c2ac2"]])

export default __exports__